module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap"
  }, [_c('b', [_vm._v("TOOLS AND SUPPLIES")])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c1"
    }
  }, [_c('b', [_vm._v("Meet the Sewing Machine")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Anatomy of a Sewing Machine")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sewing machine is your most-used (and treasured!) tool. While there are differences among brands and within brands, the same general components work similarly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('b', [_vm._v("1")])]), _vm._v(" The "), _c('b', [_vm._v("Hand Wheel")]), _vm._v(" moves the needle up and down. It is best to turn the wheel towards you. Only turn it away from you if necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('b', [_vm._v("2")])]), _vm._v(" The "), _c('b', [_vm._v("Bobbin Winder")]), _vm._v(" is the location for placing the bobbin when it is being wound.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('b', [_vm._v("3")])]), _vm._v(" The thread is placed on the "), _c('b', [_vm._v("Spool Holder")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('b', [_vm._v("4")])]), _vm._v(" The "), _c('b', [_vm._v("Stitch Indicator")]), _vm._v(" displays the stitch you are sewing, i.e., straight or zigzag.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('b', [_vm._v("5")])]), _vm._v(" The "), _c('b', [_vm._v("Stitch Width and Length Indicator")]), _vm._v(" displays the width and length of the stitch. The width is left to right and the length is the distance front to back; each stitch has a default that you can then adjust.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('b', [_vm._v("6")])]), _vm._v(" The "), _c('b', [_vm._v("Speed Indicator")]), _vm._v(" controls the speed of the needle and feed dogs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('b', [_vm._v("7")])]), _vm._v(" Thread travels through the "), _c('b', [_vm._v("Tension Discs")]), _vm._v(" on the way to the needle. Changing the tension causes the discs to tighten or loosen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('b', [_vm._v("8")])]), _vm._v(" The "), _c('b', [_vm._v("Take-Up Lever")]), _vm._v(" moves up and down as you stitch pulling the thread from the spool through the tension discs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('b', [_vm._v("9")])]), _vm._v(" The "), _c('b', [_vm._v("Tension Dial")]), _vm._v(" sets how loose or tight the tension discs are.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('b', [_vm._v("10")])]), _vm._v(" The "), _c('b', [_vm._v("Presser Foot")]), _vm._v(" holds the fabric to the feed dogs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('b', [_vm._v("11")])]), _vm._v(" The "), _c('b', [_vm._v("Stitch Plate")]), _vm._v(" is the metal plate below the needle and presser foot; it covers the bobbin area and is marked with seam allowance guidelines.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('b', [_vm._v("12")])]), _vm._v(" The "), _c('b', [_vm._v("Feed Dogs")]), _vm._v(" move the fabric under the needle and presser foot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('b', [_vm._v("13")])]), _vm._v(" The "), _c('b', [_vm._v("Disengage Feed Dogs Switch/Button")]), _vm._v(" lowers the feed dogs to allow for free motion under the needle and presser foot so the sewist moves the fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('b', [_vm._v("14")])]), _vm._v(" The "), _c('b', [_vm._v("Bobbin")]), _vm._v(" provides the bottom thread and can be located on the top, front, or side "), _c('i', [_vm._v("(vintage machines)")]), _vm._v(" of the machine. Each style has pros and cons. A top loader allows the sewist to see how much bobbin remains, while the front loader has the straightest stitch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('b', [_vm._v("15")])]), _vm._v(" The "), _c('b', [_vm._v("Foot Pedal")]), _vm._v(" makes the machine stitch. It can also be used to control the speed.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg6_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "boxt"
  }, [_c('b', [_vm._v("Adjusting Tension")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the majority of fabrics, most machines will not require you to adjust the tension. If you find that your stitches are not balanced, make slight adjustments until your stitch is balanced. If your upper thread is too tight and the bobbin thread can be seen on the top, decrease the tension. If your upper thread is too loose and can be seen on the bottom, increase the tension. Balanced tension looks the same on the top and bottom and is the ideal stitch.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Decrease tension")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Increase tension")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Balanced tension")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Ideal stitch")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Features")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Consider and prioritize the features you will actually use. A good basic machine will include straight stitch, zigzag, and reverse. There are many bonus features you may want: needle threader, automatic buttonhole, automatic cutter, automatic presser foot up/down, a needle up/needle down option, decorative stitches or machine embroidery. Consider the ones you will frequently use and the price you are paying for that feature.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Presser Feet")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some presser feet will come with your machine. A machine will typically have a general-purpose foot, a zipper foot, and a small selection of specialty feet. Specialty presser feet offer an enhanced sewing experience to specific stitches or applications. A popular specialty foot is the walking foot, which works as a second set of feed dogs to better grip and move thick or layered fabric. As you grow your skills, you will expand on the presser feet you own and use.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "boxt"
  }, [_c('b', [_vm._v("Name Your Bestie")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Naming your sewing machine is a fun tradition! Plus, it’s nice to say, “Come on, Marta!” when I need her to stitch through a thick fabric or finish a seam before the bobbin runs out. My current machine, Marta, joins a long line of BERNINAs, including Bert, Bert II, Macy, Pippi, and Gene. I also have Lulee, the vintage featherweight named for my grandmother. What name will you choose?")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Using Your Machine")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("The Manual is Your Friend")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "dd"
  }, [_c('b', [_vm._v("Read your manual.")])]), _vm._v(" I have been sewing for years and every time I get a new machine, I read the manual cover to cover. I learn something new each time! Seriously, read your manual. Each machine will have its own method of winding a bobbin, threading, and fixing errors. The manual will answer a lot of questions specific to your machine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Your manual should always be nearby. If you take a class, take your manual. An experienced sewist or teacher can better help you if you have your manual. Manuals are often available online.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Common Issues")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_c('span', {
    staticClass: "nn"
  }, [_vm._v("•")]), _vm._v("Always make sure the presser foot is up when threading the machine. This opens the tension discs and allows the thread to travel freely while threading.")]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_c('span', {
    staticClass: "nn"
  }, [_vm._v("•")]), _vm._v("Cross-wound thread can be on a vertical or horizontal spool holder. Straight wound thread must be on a vertical spool holder. See more on "), _c('a', {
    attrs: {
      "href": "#/xhtml/#c3"
    }
  }, [_vm._v("Threads")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_c('span', {
    staticClass: "nn"
  }, [_vm._v("•")]), _vm._v("If your thread is breaking, the 2 best fixes are a new needle or a thread stand that can be set further from the machine. You may not have the correct needle. See more on "), _c('a', {
    attrs: {
      "href": "#/xhtml/#c4"
    }
  }, [_vm._v("Needles")]), _vm._v(". The thread stand is separate from your machine and allows the thread a longer distance from spool to needle, which helps to even out the tension, preventing breakage.")]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_c('span', {
    staticClass: "nn"
  }, [_vm._v("•")]), _vm._v("Remove the dust from your machine with a brush whenever you change the bobbin. A clean up can solve a lot of problems. Never use canned air or anything that blows into the machine, including your breath. It causes the dust to build up and adds moisture inside the machine.")]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_c('span', {
    staticClass: "nn"
  }, [_vm._v("•")]), _vm._v("If the thread is bunching up and looking like a bird nest on the bottom, the problem is likely the threading on the top of your machine. If the bird nest is on top, the problem likely is with the bobbin. It’s the opposite of what you’d expect.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_c('span', {
    staticClass: "nn"
  }, [_vm._v("•")]), _vm._v("Hold the thread tails to the back when you begin stitching. The tails are the top and bobbin threads; your machine will stitch better at the beginning if you hold onto the tails.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_c('span', {
    staticClass: "nn"
  }, [_vm._v("•")]), _vm._v("The wrong needle, a blunt needle, or a needle that is not fully inserted into the machine often causes skipped stitches. See more on "), _c('a', {
    attrs: {
      "href": "#/xhtml/#c4"
    }
  }, [_vm._v("Needles")]), _vm._v(". A skipped stitch is exactly what it sounds like; the machine failed to make a stitch and there is an extra long stitch. If you get skipped stitches, you can sew over the seam again; it does not need to be removed unless it needs to be aesthetically pleasing, such as "), _c('a', {
    attrs: {
      "href": "#/xhtml/0008_chaptertitle002#topse1"
    }
  }, [_vm._v("Top Stitching")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_c('span', {
    staticClass: "nn"
  }, [_vm._v("•")]), _vm._v("Take care to have the correct bobbin. Bobbins can look similar but be slightly different heights or diameters.")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "box1t"
  }, [_c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "",
      "src": "images/pg8_3.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Listen to My Grandmother")])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_c('i', [_vm._v("Gaga really knew how to keep the machine happy. If the machine was being finicky, she said to re-thread, then pull out the bobbin and re-thread that. If that didn’t solve it, change your needle. Most of the time, one of these three steps will fix the problem and have you backstitching up a storm!")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c2"
    }
  }, [_c('b', [_vm._v("Fabric")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fabric options can seem endless. Instead of feeling overwhelmed, look at them as endless opportunities! There is a lot to consider when choosing fabric, but you’ll develop favorites over time. Fabric content can vary from natural cotton and linen to synthetic polyester and rayon. Once you find something you love sewing with, you can buy different colors and prints for new creations. I use the same brands and types of fabric over and over.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "boxt"
  }, [_c('b', [_vm._v("What Is a Selvage?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The selvage of fabric is thicker and coarser than the body of the fabric. With printed fabric, it is the area the gripper holds during the printing process. With woven fabric, it is the edge that forms as the fabric is woven. Printed selvages provide information on the fiber content, designer, and ink colors used in printing. Woven fabrics offer the opportunity to use a beautiful fringed edge on your project.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Types of Fabric")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Lawn/Voile")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tightly woven small threads give it a soft feel and gentle drape. It makes a lovely bag lining in addition to being a popular garment fabric. Lawn has thicker thread than voile but they are similarly soft with higher thread counts than quilting cotton. It is often made with cotton, but can be produced with other materials.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Woven")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Different colors of thread are woven to create a design. Plaid and gingham are often woven. Shot cottons use one thread color for "), _c('i', [_vm._v("weft")]), _vm._v(" and a different color for "), _c('i', [_vm._v("warp")]), _vm._v(" which creates an iridescent quality to the fabric. (For weft and warp, see "), _c('a', {
    attrs: {
      "href": "#/xhtml/#sgvb3"
    }
  }, [_vm._v("Straight Grain Versus Bias")]), _vm._v(") The threads are yarn dyed so that the color is applied to the thread/yarn before the fabric is woven.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Quilting Cotton")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These are made from cotton and typically a medium weight fabric. Designs are printed onto the fabric after it is woven.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Flannel")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Similar to quilting cotton, it has a fuzzy soft finish and looser weave.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Felted Wool")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The wool is heated and washed to create a felt made of wool. Felt does not ravel and provides a clean edge that does not need to be concealed.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Corduroy")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This popular garment fabric has a soft texture and durability that makes it also popular for home decor and bag making. Wale count is an indicator of thickness of the cords (wales); the higher the number, the smaller the wale. Most corduroy is made from cotton.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Denim")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Denim comes in almost every shade of blue, as well as other colors, and a wide range of weights. It is a popular choice for garments and bags. Typically it is cotton, but it can be a blend.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Velvet")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This plush fabric is used in home decor, bag making, and garment sewing. Fiber content can vary, but typically includes a synthetic fiber. Velvet can be challenging to stitch with, so it’s not recommended for your first project.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Canvas")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Canvas is a thicker woven fabric, often made with cotton or a cotton blend. It has more body making it an ideal bag sewing fabric.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "boxt"
  }, [_c('b', [_vm._v("Stretch it Out")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Knit, Ponte, nylon, and other stretchy fabric are ideal for garment sewing. While these fabrics have wonderful qualities, they don’t work well for the projects in this book. You will use different needles and oftentimes a serger or overlocker in lieu of a sewing machine for a project using stretch fabric. Stretchy stitching is a different world.")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Things to Consider When Choosing Fabric")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Width")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fabric typically comes on a bolt that is 45˝–60˝ (110–150cm) wide. Quilting cotton is typically 45˝ (110cm) wide. Cotton voile and lawn are typically 54˝ (140cm). Home decor, canvas, and sturdier substrates are often 60˝ (150cm). There is not an industry standard and you’ll find plenty of exceptions. The yardages in this book are based on 42˝ (107cm) -wide fabric, because the usable area is narrower than the complete width. The phrase “width of fabric” refers to this. It will often appear in patterns as width of fabric or abbreviated “WOF.”")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Quality")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cost can be an indicator of quality but it can also be an indicator of expensive content. Silk is more expensive than cotton, but that doesn’t mean it is better for your project. A look-through test can be an indicator of quality. If you’re looking for a quilting cotton that is medium weight, it shouldn’t be see-through.")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "box1t"
  }, [_c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "",
      "src": "images/pg8_3.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Follow the Pattern")])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_c('i', [_vm._v("The first time you make a project from a pattern, follow the fabric suggestions of the pattern writer. The sample they made to test the pattern is a great indicator of what fabric will work well.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Touch Test")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Consider the drape and fabric content when you are selecting your fabric. This is my biggest factor when choosing fabric. If you don’t like how it feels now, you won’t like it after you’ve spent time making it into something else. No color or design can outweigh a failed touch test! If it feels slippery when you touch it, it will feel like sewing water on the machine.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Directionality")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If a fabric has a design or print, it can be directional. If the motif, such as wildlife needs to be right side up, you’ll need to consider this when cutting. Some graphic prints are directional but look attractive in both directions; you will want to take care to cut your pieces in the same direction. Fabric that is directional can sometimes require additional yardage.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Drape")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is exactly what it sounds like. How the fabric drapes and moves is an indicator of how it will drape and move once you sew it into something. Thinner fabrics have more drape, while heavier fabrics have more body and are boxy.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Thread Count")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thread count tells you the threads per inch. However, all threads are not created equal. The thread for lawn fabric is fine, while the thread for quilting cotton is thicker. It can be a good indicator of how thin or heavy a fabric is; however, unless the threads are similarly sized, it’s not apples to apples.")]), _vm._v(" "), _c('div', {
    staticClass: "dot"
  }, [_c('p', {
    staticClass: "indent1"
  }, [_c('b', [_vm._v("PREWASHING")])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Consider both the fabric content and the finished project when deciding whether or not to prewash. Rayon, linen, and cotton can shrink so prewashing is recommended. If it’s a project you’ll want to wash often, then prewashing is also recommended. If I plan to wash my finished project, I always prewash. Dye-trapping sheets are available in the laundry aisle and will collect dye before it can bleed onto other fabrics in the wash.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "boxt",
    attrs: {
      "id": "sgvb3"
    }
  }, [_c('b', [_vm._v("Straight Grain Versus Bias")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_vm._v("Straight of grain")]), _vm._v(" refers to following along the threads that make up the fabric. The thread that runs left to right is called the "), _c('b', [_vm._v("weft")]), _vm._v(". This is easy to remember because weft rhymes with left. The "), _c('b', [_vm._v("warp")]), _vm._v(" runs up and down parallel to the selvage. "), _c('b', [_vm._v("Bias")]), _vm._v(" is the 45° angle from straight of grain.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c3"
    }
  }, [_c('b', [_vm._v("Threads")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Let’s kick this off by saying that thread labels are not standard and can be confusing to even an experienced sewist. Find a few threads that are available to you locally and stick to them. I’ve highlighted a great set as a starting point. While I have a drawer full of thread, I rely on the same types over and over, just changing the color. The touch test is a valuable resource when selecting thread!")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Go-To Threads (see chart)")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("How to Read the Thread Label")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most threads will be labeled with weight and ply in addition to fiber content. If this information is missing from the label, consult the manufacturer’s website.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Weight")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The weight of thread is a mathematical formula based on the weight of the content and the number of meters in that weight. While it is more likely to be consistent within a brand, it is not consistent across brands. The most commonly used thread is 50-weight. One brand of 50-weight may feel different from another brand of 50-weight. A cotton 50-weight will feel different from a polyester 50-weight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sewing machine thread is typically between 12-weight and 100-weight. A smaller number indicates a thicker thread, with 12-weight being the thickest and 100-weight being the thinnest. This is the opposite of sewing machine needle sizes.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Ply")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ply tells you how many individual threads are wrapped together to form the thread. A 2-ply thread is made of 2 strands, while a 3-ply thread is made of 3 strands and so on.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("2-ply versus 3-ply thread")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_c('i', [_vm._v("* This thread was used for the projects in this book, except the Carryall Tote.")])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_c('i', [_vm._v("** This thread was used for the "), _c('a', {
    attrs: {
      "href": "#/xhtml/0015_chaptertitle008"
    }
  }, [_vm._v("Carryall Tote")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Things to Consider when Choosing Thread")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Color")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most of the time, a neutral is the best option. Having a light, medium and dark in both tans and grays will cover most thread needs. If you’re topstitching, you can find a color match to blend in or use a contrasting neutral. If you’re color matching, a slightly lighter thread will blend better than a slightly darker thread.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Colorfast")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Colorfast means that the color will not fade from time or regular washing.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Matching Fibers")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If the fabric is a natural fiber, such as linen or cotton, use a natural fiber thread such as cotton. If using polyester fabric, use polyester thread. The fibers will have similar qualities and stretch. I match fibers 99% of the time and cotton is my go-to.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Coating")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thread with a wax coating should not be used in a sewing machine. This is only intended for hand stitching.")]), _vm._v(" "), _c('div', {
    staticClass: "dot"
  }, [_c('p', {
    staticClass: "indent1"
  }, [_c('b', [_vm._v("CROSS-WOUND VERSUS STRAIGHT-WOUND THREAD")])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Cross-wound thread has an X design to the way the thread is on the spool. Straight wound thread is wound in straight lines around the spool.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13_1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "boxt"
  }, [_c('b', [_vm._v("Is It Too Old?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thread does not improve with age. It can become brittle after many years. While your grandmother’s stash is a great place to find vintage scissors, old thread should not be used. I do a pull test; if I can break it easily with my hands, I toss it. Save the cute wooden spool though!")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13_2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c4"
    }
  }, [_c('b', [_vm._v("Needles")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most sewing machine needles work in all sewing machines. There are few exceptions. Many sewing machine branded needles are made by large needle brands, so don’t focus on the brand, focus on the size and needle type. The most frequently used needle for general sewing needle is size 80/12 universal; it is a good default to keep on your machine. I use an 80/12 microtex/sharp most of the time. Needle size will be determined by thread size, and to a lesser degree, fabric weight and type. The thread will lie in the groove of the needle. The groove size enlarges as the needle size enlarges. The higher the number, the larger the needle is. This is the opposite of thread and hand-sewing needles.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('i', [_vm._v("* The European system is 60–120; the United States system is 8–19.")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "boxt"
  }, [_c('b', [_vm._v("Needle Tips")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You need a fresh needle after 6–8 hours of sewing. I change mine after any large project or 2–4 small projects. It’s an inexpensive fix for a lot of problems. If you don’t remember the last time you changed the needle, it is time!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Take care to insert the needle fully into the machine and tighten the screw. Most machines have the flat edge to the back, but some vintage models are different.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c5"
    }
  }, [_c('b', [_vm._v("Interfacings and Stabilizers")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Interfacing is designed to add stability to a project while still maintaining the feel of the fabric. Stabilizer is rigid and has paperlike qualities. Typically, stabilizer is removed from the finished project and common in projects like machine embroidery. Interfacing remains in the finished project.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both interfacing and stabilizers come in various weights, from light to heavy. Interfacing can be sew-in, 1-sided fusible, or 2-sided fusible.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg15_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "box1t"
  }, [_c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "",
      "src": "images/pg8_3.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Use Fabric as Interfacing")])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_c('i', [_vm._v("Thicker fabric, such as denim or canvas can work as interfacing. Check the fabric content to be sure it’s something you want. Treat the fabric like a sew-in interfacing. Stitching the exterior fabric to the canvas/denim helps it to hold together. Don’t throw those jeans out; save them for your next bag!")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "boxt"
  }, [_c('b', [_vm._v("Tips for Ironing Interfacing to Fabric")])]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_c('span', {
    staticClass: "nn"
  }, [_vm._v("•")]), _vm._v("Follow the directions provided by the manufacturer for time, temperature, and dampness. The directions are available online.")]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_c('span', {
    staticClass: "nn"
  }, [_vm._v("•")]), _vm._v("Cutting the interfacing exactly the same size as the fabric piece and then pressing does not work well. It tends to shift causing glue to transfer to the pressing surface and iron.")]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_vm._v("Try one of these methods instead.")]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_c('b', [_vm._v("1.")]), _vm._v(" Cut the interfacing minus one seam allowance.")]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_c('b', [_vm._v("2.")]), _vm._v(" Center the interfacing on the fabric and press. This prevents glue from getting on the iron and the interfacing will be missing on only half of the fabric within the seam allowance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another way to protect the iron is to use the tip of the iron and press the interfacing to the fabric only in the middle of the piece, leaving the edges loose. Finish cutting the piece through both layers, and then press the interfacing fully to the fabric. This method works well for pattern shapes that have irregular edges. It also provides interfacing-free scraps.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c6"
    }
  }, [_c('b', [_vm._v("Tools and Notions")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg16_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Must-Haves")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1")]), _vm._v(" Clover Flower Head Pins")]), _vm._v(" are ideal for medium- to heavyweight fabric. The thicker shaft resists bending as it travels through multiple layers, working well with interfaced fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('b', [_vm._v("2")])]), _vm._v(" "), _c('b', [_vm._v("Clover Wonder Clips")]), _vm._v(" can be used in place of pins on heavier fabrics and bulkier seams.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("3")]), _vm._v(" Clover Seam Ripper")]), _vm._v(" is for seam removal. See "), _c('a', {
    attrs: {
      "href": "#/xhtml/0008_chaptertitle002#srip3"
    }
  }, [_vm._v("Seam Ripping")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("4")]), _vm._v(" Dritz Seam Gauge")]), _vm._v(" allows for short measurement. The slide can mark a seam allowance for reference. The pointed tip can be used as a point turner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("5")]), _vm._v(" Snips")]), _vm._v(" are small scissors perfect to cut thread.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("6")]), _vm._v(" Gingher Knife Edge Scissors")]), _vm._v(" cut clean edges; they are ideal for longer passes of cutting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("7")]), _vm._v(" OLFA Splash Rotary Cutter")]), _vm._v(" is sturdy and has an easy change blade.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("8")]), _vm._v(" OLFA 6˝ × 24˝ (15.2 × 61cm) Acrylic Ruler")]), _vm._v(" is frosted to stick to fabric and prevent slippage. It is clearly marked and easy to read.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("9")]), _vm._v(" Point turner")]), _vm._v(" helps to push out corners.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("10")]), _vm._v(" Measuring tape")]), _vm._v(" allows for easy measuring along curves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("11")]), _vm._v(" Bohin Hand Sewing Assortment Pack")]), _vm._v(" offers a variety of hand-stitching needles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("12")]), _vm._v(" Oliso Pro 1600 Smart Iron")]), _vm._v(" offers an automatic lift for easier ironing")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("13")]), _vm._v(" June Tailor Cut and Press")]), _vm._v(" serves as both cutting surface and pressing surface. It is also a great tool for travel.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "boxt",
    attrs: {
      "id": "makop9"
    }
  }, [_c('b', [_vm._v("Marking Tools")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_vm._v("Clover Water Soluble White Pencil")]), _vm._v(" marks on darker fabric and erases with water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_vm._v("Clover Chaco Liner")]), _vm._v(" comes in multiple colors and can be brushed or washed away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_vm._v("Dritz Home Dual Marking Pen")]), _vm._v(" offers one ink that vanishes in 24 hours and another that is water soluble.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_vm._v("FriXion")]), _vm._v(" pens come in a wide range of easy to see colors and widths. They erase with heat, but come back if cooled. There is a faint wax halo that remains at room temperature so they are best for the back of the project or seam allowances.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg17_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Always test removing the marking on a scrap from your project prior to use.")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg17_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Nice-to-Haves")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("1")]), _vm._v(" OLFA 18˝ × 24˝ (45.7 × 61cm) Cutting Mat")]), _vm._v(" allows for enough room to cut most projects. Must be stored flat out of the direct sun and away from heat sources.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("2")]), _vm._v(" Karen Kay Buckley Serrated Perfect Scissors")]), _vm._v(" cut fabric into shapes. Serrated edges hold the fabric for easier curve cutting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("3")]), _vm._v(" Fray Check")]), _vm._v(" treats a seam to prevent fraying; used for buttonhole stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("4")]), _vm._v(" June Tailor Starch Savvy")]), _vm._v(" adds body to the fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("5")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://StylistsSprayers.com",
      "target": "_blank"
    }
  }, [_vm._v("StylistsSprayers.com")]), _vm._v(" Spray Water Bottle")]), _vm._v(" sprays a fine mist of water and is a great companion for ironing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("6")]), _vm._v(" Buttonhole Cutter with Wooden Block")]), _vm._v(" is an extremely sharp tool to cut the fabric in the middle of the buttonhole.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("7")]), _vm._v(" Thread Stand")]), _vm._v(" is an independent spool holder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("8")]), _vm._v(" Dritz Metal Measuring Gauge")]), _vm._v(" displays common seam allowances allowing you to check your gauge confirming that your seam allowance is accurate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("9")]), _vm._v(" Clover Fine Quilting Pins")]), _vm._v(" are ideal for light to medium weight fabric.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e6de3c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/0007_chapter-title-001.vue
// module id = 69
// module chunks = 0